import { ProductIDs } from './base';

export const CanstarIDs = {
  PowerBusiness: 'canstarblue-powerbus',
  PowerHouseGas: 'canstarblue-powerhousegas100-0725',
  PowerHouse: 'canstarblue-powerhouse0525elec',
  PowerOffset: 'canstarblue-poweroffset',
  SwitchSaver: 'canstarSWSdigital200',
} as const;

export type CanstarIDValues = (typeof CanstarIDs)[keyof typeof CanstarIDs];

// Excludes products that do not have a Canstar promo
export type CanstarValidIDs = Extract<
  ProductIDs,
  | typeof ProductIDs.PowerBusiness
  | typeof ProductIDs.PowerOffset
  | typeof ProductIDs.SwitchSaver
  | typeof ProductIDs.PowerHouse
  | typeof ProductIDs.GasPowerHouse
  | typeof ProductIDs.GasPowerOffset
>;

export const CanstarPlanIDMapping: Record<
  CanstarValidIDs,
  CanstarIDValues | undefined
> = {
  [ProductIDs.PowerBusiness]: CanstarIDs.PowerBusiness,
  [ProductIDs.PowerOffset]: CanstarIDs.PowerOffset,
  [ProductIDs.SwitchSaver]: CanstarIDs.SwitchSaver,
  [ProductIDs.PowerHouse]: CanstarIDs.PowerHouse,
  [ProductIDs.GasPowerHouse]: CanstarIDs.PowerHouseGas,
  [ProductIDs.GasPowerOffset]: CanstarIDs.PowerOffset,
};
